<template>
  <div>
    <div class="account">
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        class="form"
        name="registUserForm"
        @submit.prevent="validateBeforeSubmit()"
      >
        <p class="account-required"><small>*</small>は必須項目です</p>

        <div class="form__group email-wrapper">
          <div class="form__group">
            <label class="form-label">
              認証メールアドレス<small>*</small>
            </label>
            <p>{{ form.mail }}</p>
          </div>
          <Btn
            :label="'変更'"
            :color="'borderRed'"
            class="edit-btn"
            @click.native="$router.push({ name: 'MailChangeStep01Mail' })"
          />
        </div>

        <div class="form__group email-wrapper">
          <div class="form__group">
            <label class="form-label">パスワード</label>
            <p>*******</p>
          </div>
          <Btn
            :label="'変更'"
            :color="'borderRed'"
            class="edit-btn"
            @click.native="$router.push({ name: 'PasswordChangeStep01Form' })"
          />
        </div>

        <InputText
          v-model="form.surname"
          :label="'氏名（姓）'"
          :placeholder="'山田'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32"
          class="form__group"
        />

        <InputText
          v-model="form.first_name"
          :label="'氏名（名）'"
          :placeholder="'太郎'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32"
          class="form__group"
        />

        <InputText
          v-model="form.surname_kana"
          :label="'氏名カナ（セイ）'"
          :placeholder="'ヤマダ'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32|katakana"
          class="form__group"
        />

        <InputText
          v-model="form.first_name_kana"
          :label="'氏名カナ（メイ）'"
          :placeholder="'タロウ'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32|katakana"
          class="form__group"
        />

        <InputText
          v-model="form.tel"
          :label="'電話番号（ハイフン無し）'"
          :maxlength="11"
          :is-require="true"
          :placeholder="'09012345678'"
          rules="required|min:10|max:11|format_tel"
          class="form__group"
        />

        <div class="form__group postcode-wrapper">
          <InputText
            v-model="form.post_code"
            :label="'郵便番号（ハイフン無し）'"
            :maxlength="7"
            :is-require="true"
            :placeholder="'1500021'"
            rules="required|min:7|max:7|zipcode"
            class="form__group"
          />
          <div class="btn-wrapper">
            <Btn
              :label="'住所検索'"
              :color="'borderRed'"
              class="postcode-btn"
              @click.native="submitPostCode"/>
          </div>
        </div>
        <p
          v-if="errAddress"
          class="form-valiTxt">
          {{ errAddress }}
        </p>

        <ValidationProvider
          v-slot="{ errors }"
          class="form__group"
          tag="div"
          name="都道府県"
          rules="required">
          <label
            class="form-label"
            for="prefecture_id">都道府県<small>*</small></label>
          <select
            id="prefecture_id"
            v-model="form.prefecture_id"
            name="prefecture">
            <option
              :selected="form.prefecture_id === ''"
              :value="null"
            >
              選択なし
            </option>
            <option
              v-for="(item, index) in prefectures"
              :value="item.id"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
          <span
            v-if="errors[0]"
            class="form-error">{{ errors[0] }}</span>
        </ValidationProvider>

        <InputText
          v-model="form.city_name"
          :label="'市区町村'"
          :maxlength="64"
          :is-require="true"
          :placeholder="'渋谷区'"
          rules="required|max:64"
          class="form__group"
        />

        <InputText
          v-model="form.address"
          :label="'番地・建物名'"
          :maxlength="64"
          :is-require="true"
          :placeholder="'渋谷'"
          rules="required|max:64"
          class="form__group"
        />

        <InputText
          v-model="form.birthday"
          :label="'生年月日'"
          :type="'date'"
          :placeholder="'1988 年 8 月 31日'"
          :disabled="birthdayDisabledFlag"
          :note="'一度設定した生年月日は変更できません'"
          class="form__group"
        />

        <!-- Button Submit -->
        <div class="form__group mt40">
          <Btn
            :label="'確認'"
            :color="'red'"
            :disabled="invalid || isLoading"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import searchAddress from '@/mixin/searchAddress.mixin'
import redirect from '@/mixin/redirect.mixin'
import store from '@/store'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'
import merge from 'deepmerge'

export default {
  name: 'AccountEditStep01Form',

  mixins: [
    // 住所検索 ※ 郵便番号から住所を検索する
    searchAddress,
    // リダイレクト ※ GETパラメータ (redirecturl, backurl)
    redirect
  ],

  components: {
    mapGetters,
    InputText,
    Btn
  },

  computed: {
    ...mapGetters(['isLoading']),
    ...mapGetters('prefectures', ['prefectures']),
    birthdayDisabledFlag () {
      return this.$store.getters['auth/isRegisteredBirthday']
    }
  },

  data () {
    return {
      prefecture_id: [],
      form: {
        login_password: '',
        login_password_confirmation: '',
        first_name: '',
        surname: '',
        first_name_kana: '',
        surname_kana: '',
        mail: '',
        birthday: '',
        post_code: '',
        prefecture_id: null,
        city_name: '',
        address: '',
        tel: ''
      },
      errAddress: null,
      formatDate: 'yyyy-mm-dd'
    }
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  created () {
    this.getPrefectures()

    let form = store.getters['accountEdit/form']
    if (!form.mail) {
      form = store.getters['auth/userInfo']
    }
    this.form = merge(this.form, form)
  },

  watch: {
    'form.birthday': {
      handler (val) {
        if (!val) {
          this.formatDate = 'yyyy-mm-dd'
          return
        }
        this.formatDate = this.form.birthday
      },
      deep: true,
      immediate: true
    },
    'form.tel': {
      handler (val) {
        // input typeがnumberの場合、maxlengthが効かないので桁数をwatchで制限する
        if (val.length > 11) {
          this.form.tel = val.slice(0, 11)
        }
      },
      deep: true,
      immediate: true
    },
    'form.post_code': {
      handler (val) {
        // ハイフンが含まれている場合は自動で除去
        if (val && val.includes('-')) {
          this.form.post_code = val.replace(/-/g, '')
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        store.commit('accountEdit/setForm', this.form)
        this.$router.push({
          name: 'AccountEditStep02Confirm'
        }).catch(() => {})
      }
    },

    submitPostCode () {
      this.searchAddress(this.form.post_code).then(res => {
        if (res.status === 'ZERO_RESULTS') {
          this.errAddress = '該当する住所が存在しません'
          this.form.prefecture_id = ''
          this.form.city_name = ''
          this.form.address = ''
        } else {
          // 日本以外の国をチェック
          const isJapan = res.results[0].address_components.some(component =>
            component.types.includes('country') && component.long_name === '日本'
          )

          if (!isJapan || res.results[0].address_components.length === 1) {
            this.errAddress = '該当する住所が存在しません'
            this.form.prefecture_id = ''
            this.form.city_name = ''
            this.form.address = ''
            return
          }

          this.errAddress = null

          // 住所コンポーネントを格納する配列
          const addressParts = []
          res.results[0].address_components.forEach(val => {
            if (val.types.includes('administrative_area_level_1')) {
              this.form.prefecture_id = this.prefectures.find(item => val.long_name === item.name).id
            } else if (val.types.includes('locality')) {
              this.form.city_name = val.long_name
            } else if (val.types.includes('sublocality_level_1')) {
              // sublocality_level_1を先頭に追加するようにする
              if (addressParts.length === 0) {
                addressParts.push(val.long_name)
              } else {
                addressParts.unshift(val.long_name)
              }
            } else if (val.types.includes('sublocality_level_2')) {
              addressParts.push(val.long_name)
            }
          })
          // 住所部分を結合
          this.form.address = addressParts.join('')
        }
      }).catch(err => err)
    }
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/common.css';
  @import '../../assets/css/form.pcss';

  .account {
    height: 100%;
    overflow: auto;
    &-required {
      margin: 65px 0 34px;
      color: #d7000f;
    }
    & .email-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      & .form__group {
        width: calc(100% - 86px);
      }
      & .edit-btn {
        vertical-align: middle;
        max-width: 76px;
      }
      p {
        word-wrap: break-word;
      }
    }
    & #prefecture_id {
      text-indent: 8px;
    }
    & .postcode-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 28px;
      .form__group {
        margin: 0;
      }
      & .btn-wrapper {
        width: 100%;
        max-width: 120px;
        margin-top: 28px;
        & .postcode-btn {
          max-width: 120px;
        }
      }
    }
    & input::-webkit-date-and-time-value {
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/account-edit/Step01Form.vue